module.exports = __webpack_public_path__ + "img/caret-left.b6bc95d7.svg";